import { Link } from "react-router-dom";

export default function AuthLayout({ eyebrow, title, subtitle, children }) {
  return (
    <div className="auth-page">
      <div className="auth-orb orb-one" />
      <div className="auth-orb orb-two" />
      <header className="auth-header">
        <Link to="/login" className="auth-brand">
          <span className="brand-symbol">✦</span>
          <span>
            ROULETTE <strong>24/7</strong>
          </span>
        </Link>
        <span className="auth-header-side">
          <span className="online-dot" /> THE TABLE IS OPEN
        </span>
      </header>
      <main className="auth-shell">
        <section className="auth-intro">
          <div className="auth-kicker">
            <span className="kicker-line" /> A PREMIUM EXPERIENCE
          </div>
          <div className="auth-wheel">
            <div className="auth-wheel-inner">
              <span>
                24<span className="wheel-slash">/</span>7
              </span>
              <small>ROULETTE</small>
            </div>
          </div>
          <h2>
            Every spin.
            <br />
            <em>A new moment.</em>
          </h2>
          <p>
            Your place at the table is ready. A beautifully simple way to jump
            back into the action.
          </p>
          <div className="auth-intro-footer">
            <span>✧ PREMIUM INTERFACE</span>
            <span>✧ ALWAYS ON</span>
          </div>
        </section>
        <section className="auth-card">
          <div className="auth-card-top">
            <span className="auth-eyebrow">{eyebrow}</span>
            <span className="auth-step">✦</span>
          </div>
          <h1>{title}</h1>
          <p className="auth-subtitle">{subtitle}</p>
          {children}
          <div className="auth-card-footer">
            SECURE ACCOUNT ACCESS <span>✦</span> ROULETTE 24/7
          </div>
        </section>
      </main>
      {/* <footer className="auth-site-footer">
        © {new Date().getFullYear()} Roulette 24/7{" "}
        <span>Crafted for a seamless experience</span>
      </footer> */}
    </div>
  );
}
